import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiOrder, ApiOrderFilter } from "./types";

interface OrdersListResponse {
    orders: ApiOrder[];
}

/**
 * Транспортный слой OMP — заказы (`orders.loadByFilter`).
 */
export const ordersApi = {
    /**
     * Загружает заказы по фильтру (без пагинации на стороне OMP для этого метода).
     * @param params.flt фильтр {@link ApiOrderFilter}
     * @param config опции HTTP
     * @returns массив заказов
     */
    load: async (params: { flt?: ApiOrderFilter }, config?: RequestConfig): Promise<ApiOrder[]> => {
        const data = await ompApiClient.postOmega<OrdersListResponse>("orders.loadByFilter", params, config);
        return data.orders;
    },
} as const;
